import { AlertTriangle, RotateCcw } from "lucide-react";
import { cn } from "../../lib/utils";
import { Button } from "./button.jsx";

// On-brand error panel for failed data loads — deliberately distinct from an
// EMPTY state (danger accent + alert icon + an explicit retry), so a failed
// Firestore listener never reads as "nothing here yet". `role="alert"` makes
// assistive tech announce it. Pass `onRetry` to surface a retry button (usually
// a route reload, since the real-time listeners re-subscribe on remount).
export function ErrorState({
  title = "Something went wrong",
  message = "We couldn't load this right now. Check your connection and try again.",
  onRetry,
  retryLabel = "Try again",
  className,
}) {
  return (
    <div
      role="alert"
      className={cn(
        "flex flex-col items-center justify-center gap-3 rounded-2xl border border-red-200 bg-red-50/70 p-8 text-center dark:border-red-900/50 dark:bg-red-950/30",
        className
      )}
    >
      <AlertTriangle
        className="h-8 w-8 text-red-500 dark:text-red-400"
        aria-hidden="true"
      />
      <div>
        <p className="text-sm font-semibold text-red-800 dark:text-red-200">
          {title}
        </p>
        <p className="mt-1 text-xs text-red-600 dark:text-red-300/90">{message}</p>
      </div>
      {onRetry && (
        <Button
          variant="destructive"
          type="button"
          onClick={onRetry}
          className="min-h-[44px] gap-1.5 rounded-full px-4 py-2 text-xs"
        >
          <RotateCcw className="h-3.5 w-3.5" aria-hidden="true" /> {retryLabel}
        </Button>
      )}
    </div>
  );
}
